<template>
  <el-dialog :visible.sync="visible_v" title="导出证明文件"
             width="800px"
             @close="
      () => {
        $emit('cancel')
      }
    ">
    <Form ref="addEvaluation" :label-width="120" :model="formCustom">
      <Form-item v-if="model.zjlx == '居留许可证'" label="居留许可办理：">
        <el-checkbox-group v-model="formCustom.a">
          <el-checkbox label="代办委托书-成年"></el-checkbox>
          <el-checkbox label="代办委托书-未成年"></el-checkbox>
          <el-checkbox label="工作类居留证件申请报告"></el-checkbox>
          <el-checkbox label="情况说明（宁波市出入境）"></el-checkbox>
          <el-checkbox label="情况说明（鄞州出入境）"></el-checkbox>
          <el-checkbox label="任职期间综合评价表"></el-checkbox>
          <el-checkbox label="涉外单位承诺书（宁波市出入境）"></el-checkbox>
          <el-checkbox label="涉外单位承诺书（鄞州出入境）"></el-checkbox>
          <el-checkbox label="私人事务团聚类居留证件申请报告"></el-checkbox>
          <el-checkbox label="提前发起情况说明"></el-checkbox>
          <el-checkbox label="外国人签证证件申请审批表-随行家属"></el-checkbox>
          <el-checkbox label="外国人签证证件申请审批表-员工"></el-checkbox>
          <el-checkbox label="无违法犯罪记录承诺书"></el-checkbox>
        </el-checkbox-group>
      </Form-item>
      <Form-item v-if="model.zjlx == '工作许可证'" label="工作许可办理：">
        <el-checkbox-group v-model="formCustom.b">
          <el-checkbox label="保险承诺书"></el-checkbox>
          <el-checkbox label="保险到期续保承诺书"></el-checkbox>
          <el-checkbox label="岗位职责说明"></el-checkbox>
          <el-checkbox label="工作资历证明"></el-checkbox>
          <el-checkbox label="离职证明"></el-checkbox>
          <el-checkbox label="情况说明-仅抬头个人信息"></el-checkbox>
          <el-checkbox label="任职证明"></el-checkbox>
          <el-checkbox label="入境体检承诺函-家属"></el-checkbox>
          <el-checkbox label="入境体检承诺函-员工"></el-checkbox>
          <el-checkbox label="薪资情况说明"></el-checkbox>
          <el-checkbox label="姓名情况说明"></el-checkbox>
          <el-checkbox label="邀请函-高端人才"></el-checkbox>
          <el-checkbox label="用人单位材料真实性承诺书"></el-checkbox>
          <el-checkbox label="邮寄委托书"></el-checkbox>
          <el-checkbox label="职务情况说明"></el-checkbox>
        </el-checkbox-group>
      </Form-item>
    </Form>
    <Button :loading="loading" style="margin-left: 350px;" type="primary" @click="add">
      导出
    </Button>
  </el-dialog>
</template>
<script>
import permissionList from "@/libs/handlePermission.ts";
import axios from "axios";
import {countryArr} from "./country";

export default {
  props: {
    visible: {
      type: Boolean,
      required: false
    },
    model: {
      type: Object,
      default: () => null
    },
  },
  watch: {
    visible(v) {
      console.log(v)
      this.visible_v = v
    }
  },
  name: "company",
  data() {
    return {
      columns: [
        {type: "index", title: "序号", align: "center"},
        {title: "家属姓名", key: "companyName", align: "center"},
        {title: "国籍", key: "deptName", align: "center"},
        {title: "家属类型", key: "employeeRealName", align: "center"},
        {title: "出生年月日", key: "employeePositionName", align: "center"},
        {title: "护照号码", key: "evaluationItem", align: "center"},
        {title: "护照到期日期", slot: "leaveUrl", key: "leaveUrl", align: "center"},
        {title: "居留许可号码", key: "evaluationRole", align: "center"},
        {title: "居留许可签发日期", key: "auditStatus", align: "center", slot: "auditStatus"},
        {title: "居留许可到期日期", align: "center", fixed: "right"},
        {title: "操作", slot: "action", align: "center", fixed: "right"},
      ],
      tableData: '',
      loading: false,
      countryArr: countryArr,
      addloading: false,
      defaultValue: [],
      isShow: false,
      organization: '',
      formCustom: {
        a: [],
        b: [],
      },
      visible_v: false,
      BaseUrl: process.env.VUE_APP_BASE_URL,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("getToken"),
      },
      value: 1,
      options: [],
      organizationList: [], // 组织机构列表
      ruleValidate: {
        evaluationCategory: [
          {required: true, message: '请填写', trigger: 'blur'}
        ]
      }
    }
  },
  components: {},
  mounted() {
    const list = JSON.parse(localStorage.getItem("routerList"))
    // eslint-disable-next-line new-cap
    this.btnList = new permissionList(list, this.$route.path).getList()
    let token = localStorage.getItem('getToken')
    let userString = decodeURIComponent((window.atob(token.split('.')[1].replace(/-/g, "+").replace(/_/g, "/"))))
    let user = JSON.parse(userString);
    this.roleType = user.roleType;
  },
  methods: {
    exportfile() {
      let supportingDocument = ''
      if (this.formCustom.a.length) {
        supportingDocument = this.formCustom.a.join(',')
        if (this.formCustom.b.length) {
          supportingDocument = supportingDocument + ',' + this.formCustom.b.join(',')
        }
      } else if (this.formCustom.b.length) {
        supportingDocument = this.formCustom.b.join(',')
      }
      if (supportingDocument) {
        this.loading = true
        axios({
          baseURL: process.env.VUE_APP_BASE_URL,
          url: `org/auth/employee/supportingDocument/export`,
          params: {
            supportingDocument: supportingDocument,
            employeeId: this.model.employeeId,
            employeeFamilyMemberId: this.model.employeeFamilyMemberId,
            zjlx: this.model.zjlx
          },
          responseType: "blob",
          method: "get",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("getToken"),
          },
        }).then((res) => {
          this.loading = false
          this.downloadloading = false
          const link = document.createElement("a");
          const blob = new Blob([res.data], {type: "application/zip"});
          link.href = URL.createObjectURL(blob);
          link.download = '证明文件（' + this.model.zgxm + '）'
          link.click();
          this.$emit('success')
        }).catch((error) => {
          this.loading = false
        })
      } else {
        this.$message.error('请先选择模板');
      }
    },
    add() {
      if (this.model.auditStatusSpecial == 0 && !this.model.jsxm && this.formCustom.b.includes('入境体检承诺函-家属')) {
        this.$confirmss('此人员家属有未复核的信息，是否继续导出？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '去复核',
          type: 'warning'
        }).then(() => {
          this.exportfile()
        }).catch(() => {
          this.$router.push({path: '/employee/employee', query: {check: true}})
        })
      } else {
        this.exportfile()
      }
    }
  }
}
</script>
